// import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
// import { trackPageNavigation } from '../utils/apiUtils';

// export const useRouting = () => {
//   const { anchor } = useParams();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   // Default values for anchor and journey
//   const defaultAnchor = 'ayushpay';
//   const defaultJourney = 'loan';

//   // Get current anchor and journey with fallbacks
//   const currentAnchor = anchor || defaultAnchor;
//   // Get journey from query params, fallback to default
//   const journeyFromParams = searchParams.get('journey');
//   const currentJourney = journeyFromParams || defaultJourney;

//   // Pages that should not be tracked
//   const skipTrackingPages = ['login', 'otp','personal-loan-message', 'lender-success'];


 

//   // Navigation helper that maintains the current anchor and journey
//   const navigateWithContext = (pageName) => {
//     const newPath = `/${currentAnchor}/${pageName}`;
//     navigate(newPath);
//     // Track page navigation (skip for login and OTP pages)
//     if (!skipTrackingPages.includes(pageName)) {
//       trackPageNavigation(pageName);
//     }
//   };

//   // Navigation helper for going back
//   const navigateBack = (pageName) => {
//     const newPath = `/${currentAnchor}/${pageName}`;
//     navigate(newPath);
//     // Track page navigation (skip for login and OTP pages)
//     if (!skipTrackingPages.includes(pageName)) {
//       trackPageNavigation(pageName);
//     }
//   };

//   // Get the current route context
//   const getRouteContext = () => ({
//     anchor: currentAnchor,
//     journey: currentJourney,
//     basePath: `/${currentAnchor}`
//   });


//   return {
//     anchor: currentAnchor,
//     journey: currentJourney,
//     navigateWithContext,
//     navigateBack,
//     getRouteContext
//   };
// };

// export default useRouting;
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageNavigation } from '../utils/apiUtils';

export const useRouting = () => {
  const { anchor } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const defaultAnchor = 'ayushpay';
  const currentAnchor = anchor || defaultAnchor;

  const defaultJourney = 'loan';
  const journeyFromParams = searchParams.get('journey');
  const currentJourney = journeyFromParams || defaultJourney;

  const skipTrackingPages = ['login', 'otp', 'personal-loan-message', 'lender-success', 'error'];

  // ✅ STORE ANCHOR IN LOCAL STORAGE
  useEffect(() => {
    if (currentAnchor) {
      localStorage.setItem("anchor", currentAnchor);
    }
  }, [currentAnchor]);

  // const navigateWithContext = (pageName) => {
  //   const newPath = `/${currentAnchor}/${pageName}`;
  //   navigate(newPath);
  // `replace` is for transient screens (e.g. key auto-login) that should not stay in back history.
  const navigateWithContext = (pageName, { replace = false } = {}) => {
    const newPath = `/${currentAnchor}/${pageName}`;
    navigate(newPath, { replace });

    if (!skipTrackingPages.includes(pageName)) {
      trackPageNavigation(pageName);
    }
  };

  const navigateBack = (pageName) => {
    const newPath = `/${currentAnchor}/${pageName}`;
    navigate(newPath);

    if (!skipTrackingPages.includes(pageName)) {
      trackPageNavigation(pageName);
    }
  };

  const getRouteContext = () => ({
    anchor: currentAnchor,
    journey: currentJourney,
    basePath: `/${currentAnchor}`,
  });

  return {
    anchor: currentAnchor,
    journey: currentJourney,
    navigateWithContext,
    navigateBack,
    getRouteContext,
  };
};

export default useRouting;